import { render } from "./DetalleEmpresa.vue?vue&type=template&id=7f1e2b40&scoped=true"
import script from "./DetalleEmpresa.vue?vue&type=script&lang=js"
export * from "./DetalleEmpresa.vue?vue&type=script&lang=js"

import "./DetalleEmpresa.vue?vue&type=style&index=0&id=7f1e2b40&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7f1e2b40"

export default script